import { z } from "zod";

export const CreateTableRequestSchema = z.object({
  name: z.string().trim().min(1).max(40),
  area: z.string().trim().max(40).nullable().default(null),
  seats: z.number().int().positive().max(100).nullable().default(null),
  sortOrder: z.number().int().default(0),
});
export type CreateTableRequest = z.infer<typeof CreateTableRequestSchema>;

export const UpdateTableRequestSchema = z.object({
  name: z.string().trim().min(1).max(40).optional(),
  area: z.string().trim().max(40).nullable().optional(),
  seats: z.number().int().positive().max(100).nullable().optional(),
  sortOrder: z.number().int().optional(),
  isActive: z.boolean().optional(),
});
export type UpdateTableRequest = z.infer<typeof UpdateTableRequestSchema>;
